import path from 'node:path';
import { randomUUID } from 'node:crypto';
import camelCase from 'lodash/camelCase.js';
import type {
  EmbedCategory,
  EmbeddedScriptPlacement,
} from '@wix/ambassador-devcenter-apps-v1-app-old/types';
import { componentGenerator } from '@wix/gena';
import { getEmbeddedScriptExtensionPath } from '@wix/cli-astro-definitions';
import { modifyExtensionsEntry } from '@wix/cli-project-extender';
import { getExtensionRelativePaths } from '../utils/extension-relative-paths.js';

// NOTE: path is relative to the build folder
const EMBEDDED_SCRIPT_TEMPLATE = path.resolve(
  __dirname,
  '../templates/astro/embedded-script'
);

export async function generateEmbeddedScript(
  projectFolder: string,
  route: string,
  name: string,
  scriptType: EmbedCategory,
  placement: EmbeddedScriptPlacement
) {
  const cwd = getEmbeddedScriptExtensionPath(projectFolder, route);
  const { relativePathToCodeFile, relativePathToConfigFile } =
    getExtensionRelativePaths({
      cwd,
      projectFolder,
      extensionFileName: route,
      codeFileType: 'html',
    });

  const config = {
    id: randomUUID(),
    name,
    scriptType,
    placement,
    source: relativePathToCodeFile,
  };

  await modifyExtensionsEntry(
    projectFolder,
    camelCase(route),
    relativePathToConfigFile
  );

  return await componentGenerator({
    template: EMBEDDED_SCRIPT_TEMPLATE,
    projectFolder,
    cwd,
    data: {
      route,
      config,
    },
  });
}
